import React from 'react';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { ALL_SWAG_CATEGORY } from 'swag-client-common/constants';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from './back-link.scss';
export default function BackLink({
  resetFilter
}) {
  const onBackToAllSwagClick = e => {
    e.preventDefault();
    resetFilter();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(ArrowBackIosIcon, {
    className: classes.icon,
    fontSize: "small"
  }), /*#__PURE__*/React.createElement("a", {
    href: `${APP_ROUTES.COLLECTIONS}/${ALL_SWAG_CATEGORY}`,
    className: classes.title,
    "data-link": "Back",
    onClick: onBackToAllSwagClick
  }, "Back to all swag"));
}